import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FundingSourceComponent } from '../../shared/modal/funding-source/funding-source.component';
import { AdjustLongTermCareCost } from '../../shared/modal/long-term-care-adjust-cost/ltc-adjust-cost.component';

@Component({
  selector: 'app-header-card',
  templateUrl: './header-card.component.html',
  styleUrls: ['./header-card.component.css']
})
export class HeaderCardComponent implements OnInit {
  // @Input() title: string;
  @Input() value: number;

  //USE THIS to pass back a returned object from any modals/dialogs
  @Input() dataSource: any;

  //USE THIS to pass any object necessary for the client and or modal/dialog
  @Input() clientObject: any;

  //THIS IS the return from this component to its parent (page of origin)
  @Output() newItemEvent = new EventEmitter<any>();

  title: string;
  subTitle: string;
  shortDesc: string;
  topLink: string;
  bottomLink: string;
  isLightBlueBG: boolean;
  isDarkBlueBG: boolean;
  isOrangeBG: boolean;
  isStrokeBorder: boolean;
  @Input() targetCard: string;

  constructor(public dialog: MatDialog) {
    this.newItemEvent = new EventEmitter();
   }

  ngOnInit() {
    this.assignValueToCard();
  }

  assignValueToCard() {
    //HACK: to get the add/remove SS section to work with this component I had to do this hack between Illustration-header and header-card
    //we will probably need to change this for recalcs....not sure. Leaving for now.
    if (this.targetCard == 'lifeTimeCostCard' || this.targetCard == 'lifeTimeCostCardAddSS') {
      this.title = 'Estimated <br>Lifetime Costs';
    }
    if (this.targetCard == 'netPresentValue') {
      this.title = 'Net Present Value';
    }
    if (this.targetCard == 'socialSecurityDeductionCard') {
      this.title = 'Social Security <br>Deductions';
    }
    if (this.targetCard == 'additionalFundsCard') {
      this.title = 'Additional Funds<br>&nbsp;'; //I cheated here...i know
      //this.subTitle='<u>Click to Add</u>'
    }
    if (this.targetCard == 'remainingUnfundedCard') {
      this.title = 'Remaining<br> Unfunded Costs:';
    }
    if (this.targetCard == 'startInvestmentCard') {
      this.title = 'Start Investing Today:';
      this.shortDesc = 'Needed to cover unfunded costs';
    }
    if (this.targetCard == 'longTermCareCard') {
      this.title = 'Long Term Care Cost:<br>&nbsp;';
    }
    if (this.targetCard == 'medicareDeductions') {
      this.title = 'Medicare Deductions<br>&nbsp;';
    }
  }

  fundingSolutionData = "";
  adjustedLongTermCare = "";
  fillInFundtionSolutionCard: boolean = false;
  hideSocialSecurity: boolean = false;
  reDirectModal(modalName): void {
    if (modalName == 'addFundingSource') {
      const dialogRef = this.dialog.open(FundingSourceComponent, {
        data: { modalName: modalName, dataSource: this.fundingSolutionData }
      });

      dialogRef.afterClosed().subscribe(result => {
        
        console.log('back from Funding', result)

        //if(result.length > 0){
          //reset/recalc cards in this page (i.e. unfunded card, start investing card, and you can now display the funding card)
          this.fillInFundtionSolutionCard = (result.length > 0) ? true : false;
          this.value = 0; //reset value after making changes (adding/editing/removing)
          for(let data of result){
            this.value += data.totalContribution;
          }
          //set data to be used again on same page session
          this.fundingSolutionData = result;
          //send data back to illustration page
          this.newItemEvent.emit(result);
        //}
  
      });
    }
    else if (modalName == 'removeSocSec') {
     
      //TODO: remove SS from the remaining costs in total

      this.hideSocialSecurity = true;
      this.newItemEvent.emit(true);
    }
    else if (modalName == 'addSocSec') {  
      
      //TODO: add SS back to the remaining costs in total

      this.hideSocialSecurity = false;
      this.newItemEvent.emit(false);
    }
    else if (modalName == 'adjustLTC') {     
      
      this.clientObject.ClientCareTypes = this.clientObject.ClientCareTypes.reverse();
      this.clientObject.SpouseCareTypes = this.clientObject.SpouseCareTypes.reverse();

      const dialogRef = this.dialog.open(AdjustLongTermCareCost, {
        data: { modalName: modalName, dataSource: this.adjustedLongTermCare, clientObject: this.clientObject }
      });

      dialogRef.afterClosed().subscribe(result => {
        
        console.log('back from Adjust LTC', result)
        
        this.newItemEvent.emit(result);
  
      });
    }
  }

}
